export default "__VITE_ASSET__CeZU7e8b__"